import http from "../../http";

const BASE = "/gateway/syinfopublish/api/pc/information/broadcast";

const informationLive = {
  create(param) {
    return http.spin.payload(`${BASE}/createBroadcast`, param);
  },
  update(param) {
    return http.spin.payload(`${BASE}/updateBroadcast`, param);
  },
};

export default informationLive;
